export const environment = {
  production: true,

  companyCode: 'DCMI01',
  getBusinessName: 'My Fortress Milton',
  commonCompanyCode: 'DCF01',
  getBaseURL: 'https://api.milton.staff.myfortress.com.au/api',
  getAuthURL: 'https://api.auth.myfortress.com.au/api',
  getPortalURL: 'https://clientportal.milton.myfortress.com.au',
  getAuthDomain: '.myfortress.com.au',
};
